export enum Direction {
  ASC = 'asc',
  DESC = 'desc',
}

export const sort = <T>(arr: Array<T>, sortBy: keyof T, order: Direction) => {
  const sorted = [...arr].sort((a: T, b: T) => (a[sortBy] > b[sortBy] ? 1 : -1));

  return order === Direction.ASC ? sorted : sorted.reverse();
};

export const paginate = <T>(arr: Array<T>, page: number, rowsPerPage: number) => {
  const start = page * rowsPerPage;
  const end = start + rowsPerPage;

  return arr.slice(start, end);
};

export const removeKeyFromObject = <T extends object>(object: T, key: keyof T) =>
  Object.fromEntries(Object.entries(object).filter(([objKey]) => objKey !== key));

export const getKeyFromObject = <T extends object>(object: T, key: keyof T) =>
  Object.entries(object).find(([objKey]) => objKey === key);

export const getKeys = <T extends object>(object: T, withoutItem?: keyof T) => {
  const keys = withoutItem
    ? Object.keys(object).filter((item) => item !== withoutItem)
    : Object.keys(object);

  return keys as Array<keyof T>;
};

export const formatKey = (key: string) => {
  switch (key) {
    case 'author':
      return 'Author';
    case 'estimate':
      return 'Estimate';
    case 'pValue':
      return 'p-value';

    default:
      return key;
  }
};
